<template>
  <div>
    <!--    <message v-show="error" class="error-message" :title="'Error'" :container="'.styles-box'" :type="'danger'" :direction="'down'" :message=error :duration="0"></message>-->

    <div v-show="!isGettingStripeData && !savedCards.length">
      <h3 class="h4 subtitle mb-4">Credit or debit card</h3>
      <form id="payment-form" class="card-payment">
        <div id="card-element" ref="cardElement">
          <!-- A Stripe Element will be inserted here. -->
        </div>
        <!-- Used to display form errors. -->
        <div id="card-errors" role="alert" />

        <div class="block" style="margin-top: 20px">
          <p class="control">
            <c-button color="primary" @click="addCard">
              <span class="icon"><i class="fa fa-plus" /></span>
              <span>Add card</span>
            </c-button>
          </p>
        </div>
      </form>
    </div>

    <template v-if="savedCards.length">
      <div v-for="card in savedCards">
        <h2 class="subtitle">
          Saved card
          <a class="is-link is-danger" @click="deleteCard(card.id)">
            <span>(remove)</span>
          </a>
        </h2>
        <table class="table">
          <tr>
            <td>Card type</td>
            <td>{{ card.brand }}</td>
          </tr>
          <tr>
            <td>Card number</td>
            <td>... {{ card.last4 }}</td>
          </tr>
          <tr>
            <td>Expiry</td>
            <td>
              <template v-if="isEditingCard">
                <label>
                  <span style="padding-top: 5px; padding-right: 5px; display: inline-block">Expiry month</span>
                  <input
                    v-model="expiryMonth"
                    class="input d-inline"
                    type="number"
                    style="width: 60px"
                    placeholder=""
                  />
                </label>
                <label>
                  <span style="padding-top: 5px; padding-right: 5px; padding-left: 5px; display: inline-block">
                    Expiry year
                  </span>
                  <input v-model="expiryYear" class="input d-inline" type="number" style="width: 75px" placeholder="" />
                </label>
                <span style="padding-top: 5px; padding-left: 5px; display: inline-block">
                  <button
                    class="button is-primary is-small"
                    :class="{ 'is-loading': isSending }"
                    @click="updateCard(card.id)"
                  >
                    <span>Update</span>
                  </button>
                  <a class="button is-small is-secondary" @click="cancelEditCard">
                    <span>Cancel</span>
                  </a>
                </span>
              </template>
              <template v-else>
                {{ card.expiryMonth }} / {{ card.expiryYear }}
                <a v-if="!isEditingCard" class="button is-primary is-small" @click="editCard(card)">
                  <span>Edit</span>
                </a>
              </template>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
// import Message from 'vue-bulma-message'
import { buildEndpoint } from '../../../libs/buildEndPoint';

export default {
  components: {
    // Message
  },

  props: {
    organisation: Object,
  },

  data() {
    return {
      stripe: null,
      card: null,
      error: null,
      isSending: false,
      isGettingStripeData: true,
      result: {},
      chargeAmount: 0,
      chargeDescription: '',
      stripeData: {
        sources: {
          data: [],
        },
      },
      savedCards: [],
      isEditingCard: false,
      expiryMonth: null,
      expiryYear: null,
      stripePublicKeyTest: 'pk_test_PIjHjzzhHDlMH9AS9WnMFzZW',
      stripePublicKeyLive: 'pk_live_E4Fa8elCOiW22lvUDfFbkEtp',
    };
  },

  watch: {},

  created() {},

  mounted() {
    this.getCustomerStripeData();
  },

  methods: {
    /**
     * Do edit card
     */
    editCard(card) {
      this.expiryMonth = card.expiryMonth;
      this.expiryYear = card.expiryYear;
      this.isEditingCard = true;
    },
    /**
     * Cancel edit card
     */
    cancelEditCard(card) {
      this.expiryMonth = null;
      this.expiryYear = null;
      this.isEditingCard = false;
    },
    /**
     * Add new card
     * @param e
     */
    addCard(e) {
      e.preventDefault();
      const _this = this;
      _this.isSending = true;
      _this.error = null;
      this.stripe.createToken(this.card).then((result) => {
        _this.isSending = false;
        if (result.error) {
          _this.error = result.error.message;
        } else {
          const data = {
            cardToken: result.token.id,
          };
          _this.$http
            .post(buildEndpoint('organisation-admin/organisation/billing/customer/add-card'), data)
            .then((response) => {
              _this.isSending = false;
              if (response.data.success) {
                _this.result = response.data.data;
                _this.getCustomerStripeData();
              } else {
                _this.error = `Error adding card: ${response.data.error}`;
              }
            })
            .catch((error) => {
              _this.error = error;
            });
        }
      });
    },
    /**
     * Update card
     */
    updateCard(cardToken) {
      const _this = this;
      const data = {
        cardToken,
        expMonth: this.expiryMonth,
        expYear: this.expiryYear,
      };
      _this.error = null;
      _this.isSending = true;
      _this.$http
        .post(buildEndpoint('organisation-admin/organisation/billing/customer/update-card'), data)
        .then((response) => {
          _this.isSending = false;
          if (response.data.success) {
            _this.result = response.data.data;
            _this.expiryMonth = null;
            _this.expiryYear = null;
            _this.isEditingCard = false;
            _this.getCustomerStripeData();
          } else {
            _this.error = `Error updating card: ${response.data.error}`;
          }
        })
        .catch((error) => {
          _this.error = error;
        });
    },
    /**
     * Delete card
     */
    deleteCard(cardToken) {
      if (window.confirm('Remove this saved card?')) {
        const _this = this;
        _this.error = null;
        const data = {
          cardToken,
        };
        _this.isSending = true;
        _this.$http
          .post(buildEndpoint('organisation-admin/organisation/billing/customer/delete-card'), data)
          .then((response) => {
            _this.isSending = false;
            if (response.data.success) {
              _this.result = response.data.data;
              this.getCustomerStripeData();
            } else {
              _this.error = `Error deleting card: ${response.data.error}`;
            }
          })
          .catch((error) => {
            _this.error = error;
          });
      }
    },
    /**
     * Initialise stripe form
     */
    setupStripe() {
      this.stripe = window.Stripe(this.stripePublicKeyLive);
      const elements = this.stripe.elements();
      // Custom styling can be passed to options when creating an Element.
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#32325d',
        },
      };

      // Create an instance of the card Element.
      const card = elements.create('card', { style });

      // Add an instance of the card Element into the `card-element` <div>.
      card.mount(this.$refs.cardElement);

      this.card = card;
    },
    /**
     * Get customer data stored in stripe
     * @param e
     */
    getCustomerStripeData(e) {
      if (e) {
        e.preventDefault();
      }
      const _this = this;
      _this.error = null;
      _this.$http
        .get(buildEndpoint('organisation-admin/organisation/billing/customer/get'))
        .then((response) => {
          _this.isGettingStripeData = false;
          if (response.data.success) {
            _this.stripeData = response.data.data;
            _this.getSavedCards();
          } else {
            _this.error = `Error getting customer: ${response.data.error}`;
          }
        })
        .catch((error) => {
          _this.error = error;
        });
    },
    /**
     * Parse saved cards from response
     */
    getSavedCards() {
      this.savedCards = this.stripeData.sources.data.map((card) => ({
        id: card.id,
        brand: card.brand,
        last4: card.last4,
        expiryMonth: card.exp_month,
        expiryYear: card.exp_year,
      }));
      if (!this.savedCards.length) {
        this.setupStripe();
      }
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  tr {
    td {
      &:first-child {
        font-weight: bold;
        width: 200px;
      }
      .not-set {
        color: silver;
      }
    }
  }
}
.card-payment {
  width: 400px;
}
/**
   * The CSS shown here will not be introduced in the Quickstart guide, but shows
   * how you can use CSS to style your Element's container.
   */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
